import { ReactNode, useCallback } from "react";
import { closeSnackbar, MaterialDesignContent, SnackbarProvider as Snackbar, SnackbarKey } from "notistack";
import { styled } from "@mui/material";
import { Close } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

type SnackbarActionProps = {
  onClick: () => void;
};

// Couldn't access theme due to it's rendering outside of config
// context which provides themes
const StyledCustomSnackbar = styled(MaterialDesignContent)(() => ({
  "&": {
    padding: "0.5rem 0.75rem",
    fontWeight: 600,
    border: "1px solid",
    borderRadius: "0.5rem"
  },
  "&.notistack-MuiContent-success": {
    backgroundColor: "#ECFDF3", // success.50
    color: "#12B76A", // success.500
    borderColor: "#12B76A" // success.500
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#FFFBFA", // error.light / error.25
    color: "#F04438", // error.500
    borderColor: "#F04438" // error.500
  },
  "&.notistack-MuiContent-warning": {
    backgroundColor: "#FFFAEB", // warning.50
    color: "#F79009", // warning.500
    borderColor: "#F79009" // warning.500
  },
  "&.notistack-MuiContent-info": {
    backgroundColor: "#f4faff", // warning.50
    color: "#2196f3", // warning.500
    borderColor: "#2196f3" // warning.500
  }
}));

export function SnackbarAction({ onClick }: SnackbarActionProps) {
  return (
    <Tooltip title='Close'>
      <IconButton size='small' onClick={onClick}>
        <Close
          fontSize='small'
          sx={{
            color: "grey.600"
          }}
        />
      </IconButton>
    </Tooltip>
  );
}

export default function SnackbarProvider({ children }: { children: ReactNode }) {
  const customSnackbarAction = useCallback(
    (id: SnackbarKey) => {
      return <SnackbarAction onClick={() => closeSnackbar(id)} />;
    },
    [closeSnackbar]
  );

  return (
    <Snackbar
      maxSnack={3}
      action={customSnackbarAction}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      Components={{
        error: StyledCustomSnackbar,
        success: StyledCustomSnackbar,
        warning: StyledCustomSnackbar,
        info: StyledCustomSnackbar
      }}
    >
      {children}
    </Snackbar>
  );
}
